module.exports = __webpack_public_path__ + "static/media/0_2020_01_25.e40ee26d.jpg";